var React = require('react');

function FurnitureCouch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m100.466 72.4661h-72v-27c0-3.313 2.687-6 6-6h60c3.313 0 6 2.687 6 6zm0-15.4512v15.451h-72v-15.451c0-2.209-1.791-4-4-4h-8c-2.209 0-4 1.791-4 4v17c0 4.419 3.582 8 8 8h88c4.418 0 8-3.581 8-8v-17c0-2.209-1.791-4-4-4h-8c-2.209 0-4 1.791-4 4zm-78 31.0003h12v-6h-12zm72 0h12v-6h-12zm-30-15.5169v-2c0-3.313-2.687-6-6-6h-30m36 8v-2c0-3.313 2.687-6 6-6h30","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3"}));
}

FurnitureCouch.defaultProps = {"height":"128","viewBox":"0 0 128 128","width":"128"};

module.exports = FurnitureCouch;

FurnitureCouch.default = FurnitureCouch;
